import type { ReactNode } from 'react'

export function Centered({ children }: { children: ReactNode }) {
	return (
		<div className="flex min-h-screen flex-col items-center justify-center gap-2 px-6 text-center">
			{children}
		</div>
	)
}
